export default __webpack_public_path__ + "static/media/background-1.de1c261d.svg";